import React from "react";
import ChargerUsageIcons from "./ChargerUsageIcons";
import "./Charger.css";
const ACChargerIntro = ({
  title,
  description,
  image,
  onReadMore,
  onEnquire
}) => {
  return (
    <section className="ac-charger-intro">
      <div className="content">
        <h1>{title}</h1>

        <p>{description}</p>

        <ChargerUsageIcons />

        <div className="buttons">
          <button className="btn-green" onClick={onReadMore}>
            Read More
          </button>
          <button className="btn-blue" onClick={onEnquire}>
            Enquire Now
          </button>
        </div>
      </div>

      <div className="image">
        <img src={image} alt={title} />
      </div>
    </section>
  );
};

export default ACChargerIntro;
